import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

export function* getCargoesByTypeName({ name = undefined, type = undefined }) {
    try {
        const response = yield call(api.getCargoByNameOrType, { name, type });

        if (response.status === 200) {
            yield put({
                type: actionTypes.GET_CARGOES_BY_TYPE_NAME.SUCCESS,
                data: response.data,
            });
            return;
        }

        yield put({
            type: actionTypes.GET_CARGOES_BY_TYPE_NAME.FAILURE,
            errors: response.errors,
        });
    } catch (e) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Something went wrong',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });
    }
}

export function* watchgetCargoesByTypeName() {
    while (true) {
        const { filter } = yield take(actionTypes.GET_CARGOES_BY_TYPE_NAME.REQUEST);
        yield fork(getCargoesByTypeName, filter);
    }
}

export default [
    watchgetCargoesByTypeName,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/names.js